import { useState } from "react";
import { shopCategories, shopMaterials } from "@/mocks/shop";

interface FilterBarProps {
  activeCategory: string;
  onCategoryChange: (c: string) => void;
}

export default function FilterBar({ activeCategory, onCategoryChange }: FilterBarProps) {
  const [showMaterials, setShowMaterials] = useState(false);

  return (
    <div className="bg-bone px-6 md:px-10 pb-10 md:pb-14">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        {/* Category pills */}
        <div className="flex items-center gap-2 flex-wrap">
          {shopCategories.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategoryChange(cat)}
              className={`px-4 py-2 rounded-full text-[13px] font-medium tracking-wide transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-forest text-bone"
                  : "bg-sand/60 text-ink hover:bg-sand"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Material toggle + sort */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => setShowMaterials((v) => !v)}
            className={`flex items-center gap-2 px-4 py-2 rounded-full text-[13px] font-medium tracking-wide transition-all cursor-pointer whitespace-nowrap ${
              showMaterials ? "bg-forest text-bone" : "bg-sand/60 text-ink hover:bg-sand"
            }`}
          >
            <i className="ri-filter-3-line text-base"></i>
            Materials
          </button>
          <div className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full bg-sand/60 text-ink text-[13px]">
            <i className="ri-arrow-up-down-line text-base"></i>
            <span className="text-ink/60">Sort:</span>
            <span className="font-medium">Newest</span>
          </div>
        </div>
      </div>

      {/* Material chips */}
      {showMaterials && (
        <div className="mt-4 flex items-center gap-2 flex-wrap animate-in fade-in slide-in-from-top-2 duration-300">
          <span className="text-xs text-ink/50 font-mono uppercase tracking-[0.18em] mr-2">Filter by:</span>
          {shopMaterials.map((mat) => (
            <span
              key={mat}
              className="px-3 py-1.5 rounded-full bg-bone border border-ink/10 text-xs text-ink/80 hover:border-ink/30 cursor-pointer transition-colors whitespace-nowrap"
            >
              {mat}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}